export default __webpack_public_path__ + "static/media/address-icon-active.69cb3432.svg";